import React from 'react'
import PropTypes from 'prop-types'

import { useLoadTimer } from '../ReactGAUtils/ReactGAUtils'

import './Progress.css'

import isEqual from 'lodash/isEqual'

const Progress = ({eventData}) => {
  useLoadTimer(eventData)
  return (<div styleName='wrapper' role='progressbar' aria-label='loading...'>
    <svg styleName='svg' viewBox='-200 -200 400 400'>
      <g styleName='g'><circle styleName='circle' r='130' pathLength='100' /></g>
    </svg>
  </div>)
}

const eventDataShape = PropTypes.shape({
  category: PropTypes.string.isRequired,
  label: PropTypes.string
})

Progress.propTypes = {
  eventData: eventDataShape.isRequired
}

export default React.memo(Progress, isEqual)
